import { render, staticRenderFns } from "./otherStaff.vue?vue&type=template&id=4ead4144&scoped=true"
import script from "./otherStaff.vue?vue&type=script&lang=js"
export * from "./otherStaff.vue?vue&type=script&lang=js"
import style0 from "./otherStaff.vue?vue&type=style&index=0&id=4ead4144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.21_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47_l4fxjmgfph2izuapsepws7m6hy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead4144",
  null
  
)

export default component.exports